import { getPath } from '@/router/common'

const baseUrl = {
  title: '客户对账考核',
  path: 'CustomerRecKpi'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'CustomerRecKpi_Index',
    component: () => import(/* webpackChunkName: "CustomerRecKpi_Index" */ '@/views/customerRecKpi/index/index.vue'),
    meta: {
      title: '客户对账考核'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'CustomerRecKpi_AddOrEdit',
    component: () => import(/* webpackChunkName: "CustomerRecKpi_AddOrEdit" */ '@/views/customerRecKpi/addOrEdit/index.vue'),
    meta: {
      title: '新增修改客户对账考核指标'
    }
  },
  {
    path: getPath('CustomerRecReport', baseUrl),
    name: 'CustomerRecKpi_CustomerRecReport',
    component: () => import(/* webpackChunkName: "CustomerRecKpi_CustomerRecReport" */ '@/views/customerRecKpi/customerRecReport/index.vue'),
    meta: {
      title: '客户对账报表'
    }
  }
]
